import { render, staticRenderFns } from "./DetailDokumentasi.vue?vue&type=template&id=74143dc7&scoped=true"
import script from "./DetailDokumentasi.vue?vue&type=script&lang=js"
export * from "./DetailDokumentasi.vue?vue&type=script&lang=js"
import style0 from "./DetailDokumentasi.vue?vue&type=style&index=0&id=74143dc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74143dc7",
  null
  
)

export default component.exports